import React, { useEffect, useState } from "react";

// Get progress percentage
const getProgreessPercent = (comp, total) => {
  return total > 0 ? Math.round((comp / total) * 100) : 0;
};

// Get progress bar color based on status
const getStatusBarGradient = (status) => {
  switch (status?.toLowerCase()) {
    case "complete":
      return "bg-gradient-to-r from-green-400 to-green-600";
    case "inprogress":
      return "bg-gradient-to-r from-blue-400 to-blue-600";
    case "notstarted":
      return "bg-gradient-to-r from-gray-300 to-gray-500";
    default:
      return "bg-gray-300";
  }
};

// Get status badge color
const getStatusBadgeColor = (status) => {
  switch (status?.toLowerCase()) {
    case "complete":
      return "bg-green-100 text-green-700";
    case "inprogress":
      return "bg-blue-100 text-blue-700";
    case "notstarted":
      return "bg-gray-100 text-gray-600";
    default:
      return "bg-gray-200 text-gray-600";
  }
};

// Status text
const statusObj = {
  inprogress: "IN PROGRESS",
  notstarted: "NOT STARTED",
  complete: "COMPLETED",
};

const StatusTable = ({
  data,
  status,
  selectedObjects,
  filteredMappingFiles,
}) => {
  const headerData = [
    "OBJECT NAME",
    "TOTAL COLUMNS",
    "IN SCOPE",
    "MAPPED",
    "PROGRESS",
    "STATUS",
  ];

  const statusTableTitle = {
    "All Statuses": "Total Objects in Scope",
    inprogress: "Objects in Progress",
    complete: "Objects Completed",
    notstarted: "Objects Not Started",
  };

  const [selectedObjectsName, setSelectedObjectsName] = useState([]);
  const [allObjectsName, setAllObjectsName] = useState([]);

  useEffect(() => {
    const selectedObjectLabels = selectedObjects.map((object) =>
      object.description?.toLowerCase().trim()
    );
    setSelectedObjectsName(selectedObjectLabels);
  }, [selectedObjects]);

  useEffect(() => {
    const allObjectLabels = filteredMappingFiles.map((object) =>
      object.description?.toLowerCase().trim()
    );
    setAllObjectsName(allObjectLabels);
  }, [filteredMappingFiles]);

  return (
    <div className="objects-list">
      <h2 className="text-2xl font-semibold text-blue-900 mb-4 w-full">
        {statusTableTitle[status]}
      </h2>
      <div className="overflow-x-auto">
        <div className="max-h-[450px] overflow-y-auto">
          <table className="objects-table w-full border-collapse">
            <thead className="bg-gray-100 sticky top-0 z-10">
              <tr>
                {headerData.map((data, idx) => (
                  <th
                    key={idx}
                    className="text-left text-sm font-semibold text-gray-700 py-3 px-4"
                  >
                    {data}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.map((obj, idx) => {
                if (
                  (status.toLowerCase() !== "all statuses" &&
                    obj.objectstatus?.toLowerCase() !== status.toLowerCase()) ||
                  !selectedObjectsName.includes(
                    obj.objectDescription?.toLowerCase().trim()
                  )
                ) {
                  return null;
                }

                if (
                  !allObjectsName.includes(
                    obj.objectDescription?.toLowerCase().trim()
                  )
                ) {
                  return null;
                }

                const percent = getProgreessPercent(
                  obj.completedscopecount,
                  obj.totalscopecount
                );
                return (
                  <tr key={idx} className="border-b hover:bg-gray-50">
                    <td className="py-3 px-4">{obj.objectDescription}</td>
                    <td className="py-3 px-4">
                      {obj.totalcolumns.toLocaleString()}
                    </td>
                    <td className="py-3 px-4">
                      {obj.totalscopecount.toLocaleString()}
                    </td>
                    <td className="py-3 px-4">
                      {obj.completedscopecount.toLocaleString()}
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex items-center gap-2 min-w-[140px]">
                        <div className="relative w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
                          <div
                            className={`h-2.5 rounded-full ${getStatusBarGradient(
                              obj.objectstatus
                            )}`}
                            style={{ width: `${percent}%` }}
                          ></div>
                        </div>
                        <div className="text-sm text-gray-700 font-medium w-[40px] text-right">
                          {percent}%
                        </div>
                      </div>
                    </td>

                    <td className="py-3 px-4">
                      <span
                        className={`text-xs font-semibold px-3 py-1 rounded-full ${getStatusBadgeColor(
                          obj.objectstatus
                        )}`}
                      >
                        {statusObj[obj.objectstatus]}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StatusTable;
